import React from 'react';
import Navbar from '../Dashboard/components/Navbar';
import Footer from '../Dashboard/components/Footer';
import QAChat from './QAChat';
import NoticeDateCalculator from './NoticeDateCalculator';
import { getAppMarket } from '../../services/MarketService';

const LegalQA: React.FC = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-emerald-50">
            <Navbar />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="mb-8">
                    <h1 className="text-2xl font-bold text-gray-900">Compliance Advisor</h1>
                    <p className="text-gray-600 mt-1">
                        {getAppMarket() === 'texas'
                            ? 'US (Texas) housing law guidance based on interpretation and application of the relevant legislation — for example the Texas Property Code Chapters 91 and 92 and the City of Dallas ordinances. Get answers about landlord obligations, tenant regulations, and compliance requirements.'
                            : 'UK housing law guidance based on interpretation and application of the relevant legislation — for example the Renters\' Rights Act 2025. Get answers about landlord obligations, tenant regulations, and compliance requirements.'}
                    </p>
                </div>
                {getAppMarket() !== 'texas' && (
                    <div className="mb-6">
                        <NoticeDateCalculator />
                    </div>
                )}
                <QAChat />
            </div>
            <Footer />
        </div>
    );
};

export default LegalQA;
